import React, { useEffect, useState, useCallback } from "react";
import { connect } from 'react-redux';
import ColliTypeForm from "./ColliTypeForm";
import { withStyles, Dialog } from "@material-ui/core";
import * as Yup from "yup";
import { parseURL } from "../../sc-utilities";
import * as actions from './store/colliTypeActions';
import History from "../../../History";
import { snackActions } from '../../sc-utilities/SnackBar';
import { hasPermission } from "../../sc-utilities";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const ColliTypeEdit = props => {
    const { classes, activeCustomerID, translations, loadColliTypeInit, onEditColliType, loadColliType, colliType, permissions, onFetchColliTypeList, onListProductTypes, location } = props;
    const [editData, setEditData] = useState({ loadingData: true, colliTypes: [], productTypes: [], formattedProductTypes: [], formattedColliTypes: [] });
    useEffect(() => {
        const fetchData = async () => {

            await loadColliType({ ActiveCustomerID: activeCustomerID, ColliTypeID: parseURL(window.location.href).colliTypeID })
        };

        fetchData();
        return () => {
            loadColliTypeInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (colliType && Object.keys(colliType).length > 0) {
            formatColliTypeData(colliType);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [colliType]);

    const formatColliTypeData = useCallback(async (colliType) => {
        // list colliTypes data

        let colliTypes = await onFetchColliTypeList({ ActiveCustomerID: activeCustomerID, q: { ...location.state } });
        if (colliTypes instanceof Array && colliTypes.length < 1) {
            snackActions.snackBarComponent("No colli types found, cannot select colli type.", "info");
        }
        let formattedColliTypes = await formatColliTypes(colliTypes, colliType.ColliHolderTypes);
        // list product types
        let productTypes = await onListProductTypes({ ActiveCustomerID: activeCustomerID, listAll: true });
        if (productTypes instanceof Array && productTypes.length < 1) {
            snackActions.snackBarComponent("No product types found, please create at least one product types first.", "info");
        }
        let formattedProductTypes = await formatProductTypes(productTypes, colliType.ProductTypes);
        setEditData({ loadingData: false, colliTypes: colliTypes, productTypes: productTypes, formattedProductTypes: formattedProductTypes, formattedColliTypes: formattedColliTypes });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const formatProductTypes = useCallback(async (productTypes = [], colliTypesProductTypes = []) => {
        let productTypeIDs = colliTypesProductTypes.map(productType => `${productType.ProductTypeID}`);
        return productTypes.filter(productType => productTypeIDs.includes(productType.value));
    }, []);

    const formatColliTypes = useCallback(async (colliTypes = [], colliTypesTypes = []) => {
        let colliTypeIDs = colliTypesTypes.map(productType => `${productType.ColliTypeID}`);
        return colliTypes.filter(colliType => colliTypeIDs.includes(colliType.value.toString()));
    }, []);

    const extractProductTypes = selectedProductTypes => {
        return selectedProductTypes.map(productType => productType.value);
    }

    const extractColliTypes = selectedColliTypes => {
        return selectedColliTypes.map(productType => productType.value);
    }

    const handleSubmit = async data => {
        let result = await onEditColliType({ ...data, ActiveCustomerID: activeCustomerID, ColliTypeID: parseURL(window.location.href).colliTypeID, ProductTypeIDs: extractProductTypes(data.ProductTypeIDs), HolderColliTypeIDs: extractColliTypes(data.HolderColliTypeIDs), WarehouseID: colliType?.WarehouseID });
        if (result) {
            setEditData({ loadingData: true });
            History.goBack()
        }
    };

    const cancelHandler = () => {
        History.goBack();
    };

    const isValid = data => {
        return (data !== null && data !== undefined)
    };

    let initialValues = {
        Name: colliType && colliType.Name ? colliType.Name : '',
        Height: colliType && isValid(colliType.Height) ? colliType.Height : '',
        Length: colliType && isValid(colliType.Length) ? colliType.Length : '',
        Width: colliType && isValid(colliType.Width) ? colliType.Width : '',
        MaxWeight: colliType && isValid(colliType.MaxWeight) ? colliType.MaxWeight : '',
        AllowHolderColliIDNull: colliType && colliType.AllowHolderColliIDNull ? true : false,
        HolderColliTypeIDs: editData.formattedColliTypes,
        ProductTypeIDs: editData.formattedProductTypes
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Height: Yup.number().notRequired(),
            Width: Yup.number().notRequired(),
            Length: Yup.number().notRequired(),
            MaxWeight: Yup.number().notRequired(),
            AllowHolderColliIDNull: Yup.boolean(),
            HolderColliTypeIDs: Yup.array().when('AllowHolderColliIDNull', {
                is: (AllowHolderColliIDNull) => AllowHolderColliIDNull !== true,
                then: Yup.array()
                    .required('Field is required')
            })
        },
        FormTitle: translations["edit_colli_type"] || "Edit colli type",
        ButtonSubmit: hasPermission(permissions, 'colli_type_save') ? {
            Title: translations["save"] || "SAVE"
        } : null,
        ButtonCancel: {
            Title: translations["cancel"] || "CANCEL",
            handleCancel: cancelHandler
        }
    };

    return (
        !editData.loadingData ?
            <ColliTypeForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                colliTypes={editData.colliTypes}
                productTypes={editData.productTypes}
                translations={translations}
            ></ColliTypeForm> :
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={editData.loadingData}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >

                <AppLogoLoading />
            </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        loading: state.logistic.colliType.editing,
        colliType: state.logistic.colliType.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onEditColliType: data => dispatch(actions.editColliType(data)),
        loadColliType: data => dispatch(actions.loadColliType(data)),
        loadColliTypeInit: () => dispatch(actions.loadColliTypeInit()),
        onFetchColliTypeList: filter => dispatch(actions.listColliTypes(filter)),
        onListProductTypes: (data) => dispatch(actions.listProductTypes(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ColliTypeEdit));


/**
 *  Translations
 *      edit_colli_type
 *
 */
